import type {
  ProjectItem,
  ShippingOptions,
} from '@customink/project-service-react-components';
import type { TurnTime } from '@customink/project-service-types';
import { TURN_TIMES } from '@customink/project-service-types';

export const lowQuantityError = 'Only available for orders of 6 or more items';
export const personalizationError =
  'Orders with names/numbers are not eligible for shipping to multiple addresses';
export const notIndividualShipEligible =
  'One or more of the selected products is not eligible to ship to multiple addresses';

// I promise this is better than an enum
export const DeliveryMethods = {
  SHIP_TO_ONE: 'shipToOne',
  SHIP_TO_MULTIPLE: 'shipToMultiple',
} as const;

// fancy ts for creating the union type of the values in the object
export type DeliveryMethod =
  (typeof DeliveryMethods)[keyof typeof DeliveryMethods];

export const getShipToMultipleLabel = (
  elgibleForDistributedShipping: boolean,
  hasPersonalization: boolean,
  individualShipEligible?: boolean,
) => {
  if (elgibleForDistributedShipping) return null;
  if (!individualShipEligible) return notIndividualShipEligible;
  if (hasPersonalization) return personalizationError;
  return lowQuantityError;
};

export type ShippingOption = {
  name: string;
  key: keyof ShippingOptions;
  value: string;
};

export const shippingCopy: Array<ShippingOption> = [
  {
    name: 'Super Rush',
    key: 'super_rush_shipping',
    value: TURN_TIMES.SUPERRUSH,
  },
  {
    name: 'Rush',
    key: 'rush_shipping',
    value: TURN_TIMES.RUSH,
  },
  {
    name: 'Standard',
    key: 'standard_shipping',
    value: TURN_TIMES.STANDARD,
  },
];

export const addFulfillment = (
  projectItems: ProjectItem[] = [],
  turnTime: TurnTime,
): ProjectItem[] => {
  return projectItems.map((item) => ({
    ...item,
    fulfillment: { priority: turnTime },
  }));
};
